import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRoleModules } from "reduxStore/action/moduleActions";
import { createRole } from "reduxStore/action/roleActions";
import strings from "translate/language";
import { errorToast } from "utils/httpClient";
import { seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import "./RoleListing.css";

const AddNewRoles = () => {
  const navigate = useNavigate();
  const [formVaild, setFormVaild] = useState(false);
  const [form, setForm] = useState({
    role_title: "",
  });
  const [showPropertOption, setShowPropertOption] = useState({});
  const [permSearch, setPermSearch] = useState("");

  const dispatch = useDispatch();
  const modulesSelector =
    useSelector((state) => state.modules.response?.data) || [];
  const rolesSelector = useSelector((state) => state.roleData) || {};

  useEffect(() => {
    dispatch(getRoleModules());
  }, []);

  useEffect(() => {
    if (rolesSelector?.create === true) {
      if (rolesSelector?.response?.status === 200) {
        navigatpage("/roles");
      } else {
        errorToast(rolesSelector?.response?.message);
      }
    }
  }, [rolesSelector]);

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  const toggleParent = (item, checked) => {
    const next = { ...showPropertOption, [item._id]: checked };
    if (!checked && item.children?.length) {
      item.children.forEach((child) => {
        next[child._id] = false;
      });
    }
    setShowPropertOption(next);
  };

  const toggleChild = (item, childId, checked) => {
    const next = { ...showPropertOption, [childId]: checked };
    if (checked) {
      next[item._id] = true;
    }
    setShowPropertOption(next);
  };

  const selectedCount = (item) => {
    let count = showPropertOption[item._id] ? 1 : 0;
    (item.children || []).forEach((child) => {
      if (showPropertOption[child._id]) count += 1;
    });
    return count;
  };

  const filteredModules = useMemo(() => {
    const q = permSearch.trim().toLowerCase();
    if (!q) return modulesSelector || [];
    return (modulesSelector || []).filter((item) => {
      if (String(item.module_title || "").toLowerCase().includes(q)) {
        return true;
      }
      return (item.children || []).some((child) =>
        String(child.module_title || "").toLowerCase().includes(q)
      );
    });
  }, [modulesSelector, permSearch]);

  const handleSubmit = () => {
    if (form.role_title === "") {
      setFormVaild(true);
      return true;
    }
    setFormVaild(false);
    const permission_module = Object.keys(showPropertOption)
      .filter((key) => showPropertOption[key] === true)
      .join(",");
    const post = {
      role_title: form.role_title,
      permission_module: permission_module,
    };
    dispatch(createRole(post));
  };

  useEffect(() => {
    seo({
      title: "Add New Role",
      metaDescription: "Add new role",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body justo-role-page">
      <Breadcrumb
        title={strings.addnewrole}
        url={"/roles"}
        parentListing={strings.roleListing}
        titleactive={strings.addnewrole}
        isBackBtn={true}
      />
      <div className="container-fluid justo-role">
        <div className="justo-role__card justo-role-form">
          <div className="justo-role-form__top">
            <div>
              <h2 className="justo-role__title">{strings.addnewrole}</h2>
              <p className="justo-role__subtitle">
                Create a role and assign module permissions.
              </p>
            </div>
            <div className="justo-role__top-actions">
              <button
                type="button"
                className="justo-role__btn justo-role__btn--ghost"
                onClick={() => navigatpage("/roles")}
              >
                {strings.cancel}
              </button>
              <button
                type="button"
                className="justo-role__btn justo-role__btn--solid"
                onClick={() => handleSubmit()}
              >
                <i className="fa fa-check" aria-hidden="true" />
                {strings.submit}
              </button>
            </div>
          </div>

          <div className="justo-role-form__meta">
            <div className="justo-role-form__field">
              <label className="justo-role-form__label" htmlFor="role_title_new">
                {strings.roleName}
              </label>
              <p className="justo-role-form__meta-hint">
                Display name shown across users and permissions.
              </p>
              <input
                className="justo-role-form__input"
                id="role_title_new"
                type="text"
                autoComplete="off"
                placeholder={strings.roleName}
                name="role_title"
                value={form.role_title}
                onChange={handleInputField}
              />
              {formVaild ? (
                <span className="justo-role-form__error">
                  {strings.rolename}
                </span>
              ) : null}
            </div>
          </div>

          <div className="justo-role-form__body">
            <div className="justo-role-form__panel">
              <div className="justo-role-form__panel-head">
                <div className="justo-role-form__panel-head-row">
                  <div>
                    <h3 className="justo-role-form__panel-title">
                      {strings.modules}
                    </h3>
                    <p className="justo-role-form__panel-hint">
                      All permissions are listed — check what this role needs.
                    </p>
                  </div>
                  <input
                    className="justo-role-form__perm-search"
                    type="text"
                    value={permSearch}
                    onChange={(e) => setPermSearch(e.target.value)}
                    placeholder="Filter modules or permissions"
                    aria-label="Filter permissions"
                  />
                </div>
              </div>
              <div className="justo-role-form__modules">
                {[0, 1].map((col) => {
                  const colModules = filteredModules.filter(
                    (_, index) => index % 2 === col
                  );
                  return (
                    <div className="justo-role-form__modules-col" key={col}>
                      {colModules.map((item, colIndex) => {
                        const index = colIndex * 2 + col;
                        const count = selectedCount(item);
                        const isActive = count > 0;
                        return (
                          <div
                            className={`justo-role-form__module${
                              isActive ? " justo-role-form__module--active" : ""
                            }`}
                            key={item._id || index}
                          >
                            <div className="justo-role-form__module-head">
                              <label
                                className="justo-role-form__check"
                                htmlFor={"chk-ani" + index}
                              >
                                <input
                                  id={"chk-ani" + index}
                                  type="checkbox"
                                  checked={!!showPropertOption[item?._id]}
                                  onChange={(e) =>
                                    toggleParent(item, e.target.checked)
                                  }
                                />
                                <span>{item.module_title}</span>
                              </label>
                              {item.children?.length ? (
                                <span className="justo-role-form__module-count">
                                  {count}/{1 + item.children.length}
                                </span>
                              ) : null}
                            </div>
                            {item.children?.length ? (
                              <div className="justo-role-form__children">
                                {item.children.map((child) => (
                                  <label
                                    className="justo-role-form__check justo-role-form__check--child"
                                    htmlFor={"chk-ani-j" + child._id}
                                    key={child._id}
                                  >
                                    <input
                                      id={"chk-ani-j" + child._id}
                                      type="checkbox"
                                      checked={
                                        showPropertOption[child?._id] || false
                                      }
                                      onChange={(e) =>
                                        toggleChild(
                                          item,
                                          child._id,
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span>{child.module_title}</span>
                                  </label>
                                ))}
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewRoles;
